import * as $ from "jquery";
import { isMobile } from "./helpers/mobile";
import Popper from "popper.js";

import "@infoprojects/slick-carousel";
import "@chenfengyuan/datepicker";
import "select2";
import "bootstrap";

import itemLead from "./functions/item-lead";
import seoLead from "./functions/seo-lead";

// Globalizing jQuery
window.$ = window.jQuery = $;

///////////////////////////////
//     Document ready
///////////////////////////////
$(document).ready(function () {
    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
    });

    // Opening of item lead on Item details page
    // If content is higher than wrapper
    itemLead();
    seoLead();
    pixels();

    // MAIN SLICK SLIDERS
    $("#main-slider").slick({
        //lazyLoad: 'ondemand',
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        speed: 600,
        prevArrow:
            '<button type="button" class="slick-prev"><span><img src="/images/icon/chevron-left-white.svg" alt="chevron-left"></span></button>',
        nextArrow:
            '<button type="button" class="slick-next"><span><img src="/images/icon/chevron-right-white.svg" alt="chevron-right"></span></button>',
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    // INDEX PROMO SLIDERS
    if (isMobile.any()) {
        $(".promo-box").slick({
            //lazyLoad: 'ondemand',
            dots: true,
            infinite: true,
            speed: 600,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: "unslick",
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    // User menu
    (() => {
        var popper, timer;

        $(".user-menu-profile").on({
            mouseenter: function () {
                var $profile = $(".user-menu-profile");
                var $menu = $(".user-menu-dd");

                if ($menu.length < 1) return;

                clearTimeout(timer);

                popper = new Popper($profile[0], $menu[0], {
                    positionFixed: true,
                    placement: "bottom-start",
                    modifiers: {
                        flip: {
                            enabled: false
                        },
                    }
                });

                $profile.addClass("open");
            },
            mouseleave: function () {
                var $profile = $(".user-menu-profile");
                var $menu = $(".user-menu-dd");

                if ($menu.length < 1) return;

                timer = setTimeout(() => {
                    popper.destroy();

                    $profile.removeClass("open");
                }, 100);
            },
        });
    })();

    // CART DROPDOWN ON HOVER
    $(".user-menu-search").on("click", () => {
        $(".main-search").toggleClass("hidden");
    });

    //MOBILE NAV OPENER
    $("#m-nav").click(function () {
        $("body").toggleClass("menu-open");
    });

    //NAV OPENER
    var slideSpeed = 150;
    if (isMobile.any()) {
        $(".catnav-item span").each(function () {
            $(this).click(function (e) {
                e.stopPropagation();
                if (!$(this).parent().hasClass("opened")) {
                    $(this).parent().addClass("opened");
                    $("body").addClass("catnav-open");
                } else {
                    $(".nav-item-box .catnav-item").removeClass("opened");
                    $("body").removeClass("catnav-open");
                }
            });
        });

        $(".nav-item-more").each(function () {
            $(this).click(function (e) {
                e.stopPropagation();
                if (!$(this).hasClass("opened")) {
                    $(".nav-item-box").slideUp(slideSpeed);
                    $(".nav-item-box .catnav-item").removeClass("active");
                    $(".nav-item-more").removeClass("opened");
                    $("body").addClass("nav-open");
                    $(this).addClass("opened");
                    $(this).find(".nav-item-box").slideDown(slideSpeed);
                } else {
                    $(this).removeClass("opened");
                    $(this).find(".nav-item-box").slideUp(slideSpeed);
                    $(".nav-item-box .catnav-item").removeClass("active");
                    $("body").removeClass("nav-open");
                }
            });
        });
    } else {
        $(".nav-item-more").click(function () {
            if ($(this).hasClass("opened")) {
                $(this).removeClass("opened");
                $(this).find(".nav-item-box").fadeOut(150);
            } else {
                // Close all others
                $(this)
                    .parent()
                    .find(".nav-item-more")
                    .removeClass("opened")
                    .find(".nav-item-box")
                    .fadeOut(150);

                $(this).addClass("opened");
                $(this).find(".nav-item-box").fadeIn(150);
            }
        });
        // $(".nav-item-more").click(
        //     function() {
        //         $(this).addClass("opened");
        //         $(this)
        //             .find(".nav-item-box")
        //             .fadeIn(150);
        //     },
        //     function() {
        //         $(this).removeClass("opened");
        //         $(this)
        //             .find(".nav-item-box")
        //             .fadeOut(150);
        //     }
        // );
    }

    //CATNAV OPENER
    if (isMobile.any()) {
        /*$('.catnav-item').each(function () {
            $(this).click(function (e) {
                e.stopPropagation();
                if (!$(this).hasClass('opened')) {
                    $('.nav-item-more').removeClass('opened');
                    $('.nav-item-box').slideUp();
                    $('.side-content > .side-item').removeClass('opened');
                    $('.side-content > .side-item > .side-content').slideUp();
                    $('.index-content > .side-content').fadeOut();
                    $(this).addClass('opened');
                    $(this).find('.nav-item-box').slideDown();
                } else {
                    $(this).removeClass('opened');
                    $(this).find('.nav-item-box').slideUp();
                    $('.index-content > .side-content').fadeIn();

                }

            })
        });*/
    } else {
        $(".catnav-item").hover(
            function () {
                $(this).parent().find(".catnav-item.active").removeClass("active");
                $(this).addClass("active");
            },
            function () {
                //$(this).removeClass('active');
            }
        );
    }

    // ORDER SELECT
    $(".select-list").each(function () {
        if ($(this).find("li").hasClass("selected") > 0) {
            $(this)
                .parent()
                .find(".select-title")
                .removeClass("no-select")
                .text($(this).find(".selected").find("span").text());
            $(this).find(".selected").find("input:radio").prop("checked", true);
        }
    });

    $("body").on(
        {
            click: function (e) {
                var $selectList = $(this).next(".select-list");
                if ($selectList.outerHeight() < 250) {
                    $selectList.css("overflow-y", "hidden");
                    /*$selectList.css({
                    'overflow-y': 'scroll',
                    'maxHeight': '250px'
                });*/
                } /*else {
				$selectList.css('overflow-y', 'hidden');
			}*/
                if ($(this).hasClass("opened")) {
                    $(this).removeClass("opened").next(".select-list").hide();
                } else {
                    $(".select-title").removeClass("opened");
                    $(".select-list").hide();
                    $(this).addClass("opened").next(".select-list").show();
                }
            },
        },
        ".select-title"
    );

    $("body").on(
        {
            click: function (e) {
                e.preventDefault();
                $(this).parent().find("li").removeClass("selected");
                $(this).parent().find("input:radio").prop("checked", false);

                if ($(this).hasClass("select-default")) {
                    $(this)
                        .parent()
                        .parent()
                        .find(".select-title")
                        .removeClass("opened")
                        .addClass("no-select")
                        .text($(this).text());
                } else {
                    var $uniClass = $(this).attr("class");
                    $(this)
                        .parent()
                        .parent()
                        .find(".select-title")
                        .attr("class", "select-title")
                        .addClass($uniClass)
                        .text($(this).text());
                    $(this).addClass("selected");
                    $(this).find("input:radio").prop("checked", true);
                }
                $(this).parent().toggleClass("opened").hide();
            },
        },
        ".select-list li"
    );

    // HIDE ORDER SELECT LAYER WHEN CLICK OUTSIDE
    $(document).mousedown(function (e) {
        var container = $(".select");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.find(".select-title").removeClass("opened");
            container.find(".select-list").hide().removeClass("opened");
        }
    });
    var submitProgress = false;
    $("#contact-form").submit(function (e) {
        e.preventDefault();
        var validate = true;
        $("#contact-form input, #contact-form textarea").each(function () {
            if ($(this).data("required") == true) {
                if ($(this).val() == "") {
                    $(this).addClass("form-control--error");
                    validate = false;
                }
            }
            if ($(this).hasClass("form-check-input")) {
                if (!$(this).prop("checked")) {
                    $(this).addClass("form-control--error");
                    validate = false;
                }
            }
        });
        if (validate) {
            var form = $(this);
            if (googleRecaptchaSiteKey) {
                grecaptcha.ready(function () {
                    grecaptcha
                        .execute(googleRecaptchaSiteKey, { action: "submit" })
                        .then(function (token) {
                            $("#contact-form-grecaptchatoken").val(token);
                            submitContactForm(form);
                        });
                });
            } else {
                submitContactForm(form);
            }
        }
    });

    $("#contact-form input, #contact-form textarea").each(function () {
        $(this).on("focusin", function () {
            $(this).removeClass("form-control--error");
        });
    });

    //HEADER STICKY
    function isSticky() {
        // var $posHeroEnd = 60;
        // if (!isMobile.any()) {
        //     var $y = $(window).scrollTop();
        //     if ($y >= $posHeroEnd) {
        //         $("body").addClass("sticky");
        //     } else {
        //         $("body").removeClass("sticky");
        //     }
        // }
    }

    isSticky();

    $(document).scroll(function () {
        isSticky();
    });

    //MAIN SEARCH FUNCTIONS
    $("#search").keyup(function () {
        if ($(this).val() != "") {
            $(".clear-search").show();
        } else {
            $(".clear-search").hide();
        }
    });

    $(".clear-search").click(function () {
        $("#search").val("").focus();
        $(this).hide();
    });

    if (isMobile.any()) {
        $("#search").attr("placeholder", "Írd be a keresett kifejezést!");
    }

    //MOBILE SEARCH OPENER
    $("#m-search").click(function () {
        $("body").toggleClass("search-open");
        $("#search").val("").focus();
        $("#search").trigger("focus");
    });

    //MOBILE LIST FILTERS OPENER
    $("#list-filters-toggle").click(function () {
        $(this).toggleClass("opened");
        $("body").toggleClass("fixed");
        $(".list-filter-col").toggleClass("opened");
    });

    //DATEPICKER
    if ($(".datepicker").length > 0) {
        $(".birth-date").datepicker({
            format: "yyyy.mm.dd.",
            language: "hu-HU",
            autoHide: true,
        });
    }

    $("body").on(
        {
            click: function (e) {
                e.preventDefault();
                $.post($(this).attr("href"), {}, (response) => {
                    console.log(response);
                });
            },
        },
        "#makeapay"
    );

    //TABS
    $("ul.tabs li").click(function () {
        var tab_id = $(this).attr("data-tab");

        $("ul.tabs li").removeClass("current");
        $(".tab-content").removeClass("current");

        $(this).addClass("current");
        $("#" + tab_id)
            .addClass("current")
            .closest("input")
            .prop("checked", true);
    });

    //GO TO TOP
    $(".go-to-top").click(function () {
        $("html,body").animate({ scrollTop: 0 }, "slow");
        return false;
    });

    window.onscroll = function () {
        if (window.scrollY > 0) {
            $(".go-to-top").css({ display: "block" });
        } else {
            $(".go-to-top").css({ display: "none" });
        }
    };

    //REG PASSWORD STRENGTH
    /*if ($(".reg_pw").length > 0) {
        $(".reg_pw").passwordStrength({
            secureStrength: 25,
            $indicator: undefined,
            indicatorClassName: "pw-strength",
            indicatorDisplayType: "block",
            points: {
                forEachCharacter: 1,
                forEachSpace: 1,
                containsLowercaseLetter: 2,
                containsUppercaseLetter: 2,
                containsNumber: 4,
                containsSymbol: 5
            },
            strengthClassNames: [
                {
                    name: "very-weak",
                    text: "Nagyon gyenge"
                },
                {
                    name: "weak",
                    text: "Gyenge"
                },
                {
                    name: "mediocre",
                    text: "Közepes"
                },
                {
                    name: "strong",
                    text: "Erős"
                },
                {
                    name: "very-strong",
                    text: "Nagyon erős"
                }
            ]
        });
    }*/

    //CATALOG OPENER
    $(".catalog-division-title").each(function () {
        var $this = $(this);

        var openFunction = function () {
            var $next = $this.next();

            if ($next.is(":visible")) {
                $this.removeClass("opened");
            } else {
                $this.addClass("opened");
            }

            $next.slideToggle();
        }

        $this.click(openFunction);

        try {
            if($this[0].classList.contains('gyikPage') || $(window?.location?.hash).children('.catalog-division-title')[0] == $this[0]) {
                openFunction()
            }
        } catch(e) {}
    });

    //BOOK PREVIEW DIALOGUE
    $(".teaser-btn").click(function () {
        window.Dibook.preview.open(this.dataset.id);
    });

    $(".teaser-audio-btn").click(function () {
        $("#audio-preview")
            .replaceWith(
                "<audio controls>" +
                    '<source src="' +
                    $(this).data("id") +
                    '" type="audio/mpeg">' +
                    "Your browser does not support the audio element." +
                    "</audio>"
            )
            .remove();
    });

    // $('.teaser-btn').click(function () {
    //     $('.preview').fadeIn();
    //     $('body').addClass('fixed');
    //     $('#preview-slider').slick({
    //         //lazyLoad: 'ondemand',
    //         dots: false,
    //         infinite: false,
    //         speed: 600,
    //         prevArrow: '<button type="button" class="slick-btn slick-prev"></button>',
    //         nextArrow: '<button type="button" class="slick-btn slick-next"></button>',
    //         slidesToShow: 2,
    //         slidesToScroll: 2,
    //         responsive: [
    //         {
    //         breakpoint: 1024,
    //         settings: {
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //         }
    //         }
    //         ]
    //     });
    // });
    // $('.preview-close').click(function () {
    //     $(this).parent().fadeOut();
    //     $('body').removeClass('fixed');
    // });

    //COOKIE SHOW
    setTimeout(function () {
        $(".cookie-agree").fadeIn();
    }, 1000);

    $("#cookie-settings").click(function (e) {
        e.preventDefault();
        $.get($(this).attr("href"), function (response) {
            if ($(".cookie-agree").length < 1) {
                $("body").append(response);
            }

            $(".cookie-agree").fadeIn();
        });
    });

    $("body").on(
        {
            submit: function (e) {
                e.preventDefault();
                $(this).find(".invalid-feedback").hide();
                $.post($(this).attr("action"), $(this).serialize(), function (response) {
                    if (response.success) {
                        $("#commonmodal .modal-body-content").text(
                            "Az adataid módosítása sikeres!"
                        );
                        $("#commonmodal button.okbutton").text("Rendben");
                        $("#commonmodal").modal("show");
                        bp("setUserProperties", {
                            userId: $("#profile_main_form").data("uid"),
                        });
                        setTimeout(location.reload, 6000); // wait 6 seconds before reloading
                    } else {
                        $(".invalid-feedback").text("");
                        $.each(response.errors, function (key, item) {
                            console.log("#" + response.source + "-" + key + " + .invalid-feedback");
                            $("#" + response.source + "-" + key + " + .invalid-feedback")
                                .text(item)
                                .show();
                        });
                    }
                });
            },
        },
        "#profile_main_form"
    );

    $("body").on(
        {
            submit: function (e) {
                e.preventDefault();
                $(".login-form button.btn").attr("disabled", true);
                $(".invalid-feedback").hide();
                if ($("#loginEmail").val() == "") {
                    $("#loginEmail + .invalid-feedback").show();
                    return false;
                }
                if ($("#loginPw").val() == "") {
                    $(".login-password + .invalid-feedback").show();
                    return false;
                }
                var signUpProperties = {
                    contentType: "Page",
                    id: "login-form",
                    name: "Belépés",
                };
                if(typeof bp != "undefined")
                    bp("track", "signUp", signUpProperties);
                $.post($(this).attr("action"), $(this).serialize(), function (response) {
                    if (!response.auth) {
                        $("#login-error").text(response.errors).show();
                    } else {
                        if(response.intended) {
                            window.location.href = response.intended;
                            return;
                        }
                        
                        location.reload();
                    }
                    $(".login-form button.btn").attr("disabled", false);
                });
            },
        },
        ".login-form"
    );

    $(".promo-box-item").click(function () {
        bp("clickPromo", {
            contentType: "Page",
            creative: $(this).find("img").attr("src"),
            id: $(this).attr("href"),
        });
    });

    $("#loginModal .tabs a").on("click", function (e) {
        e.preventDefault();
        $(".invalid-feedback").hide();
    });

    $("body").on(
        {
            submit: function (e) {
                e.preventDefault();
                var form = $(this);

                var signUpProperties = {
                    contentType: "Page",
                    id: "reg-form",
                    name: "Regisztráció",
                };
                if(typeof bp != "undefined")
                    bp("track", "signUp", signUpProperties);
                if (googleRecaptchaSiteKey) {
                    grecaptcha.ready(function () {
                        grecaptcha
                            .execute(googleRecaptchaSiteKey, { action: "submit" })
                            .then(function (token) {
                                $("#regGoogleRecapcthaToken").val(token);
                                submitRegForm(form);
                            });
                    });
                } else {
                    submitRegForm(form);
                }
            },
        },
        ".reg-form"
    );

    $('input[name="product-format"]').change(function () {
        location.href = $(this).data("url");
    });

    if (typeof popupmodal === "object") {
        $("#commonmodal .h4").html(popupmodal.title);
        $("#commonmodal .modal-body-content").html(popupmodal.content);
        if (typeof popupmodal.buttonURL != "undefined" && popupmodal.buttonURL != "") {
            $("#commonmodal button.okbutton").hide();
            $("#commonmodal a.modalbutton").show();
            $("#commonmodal a.modalbutton").prop("href", popupmodal.buttonURL);
            $("#commonmodal a.modalbutton").html(popupmodal.buttonText);
        } else {
            $("#commonmodal button.okbutton").show();
            $("#commonmodal a.modalbutton").hide();
            $("#commonmodal button.okbutton").html(popupmodal.buttonText);
        }
        $("#commonmodal").modal("show");
    }

    $("body").on(
        {
            submit: function (e) {
                e.preventDefault();

                $(this).find(".invalid-feedback").hide();
                $(this).find(".valid-feedback").hide();

                var form = $(this);
                $.post($(this).attr("action"), $(this).serialize(), function (response) {
                    response = $.parseJSON(response);
                    if (response.success) {
                        form.find(".valid-feedback").text(response.message).show();
                        form.find("input").val("");
                        $("#commonmodal .h4").text("");
                        $("#commonmodal .modal-body-content").text(response.message);
                        $("#commonmodal button.okbutton").text("Rendben");
                        $("#commonmodal").modal("show");
                    } else {
                        form.find(".invalid-feedback").text(response.message).show();
                    }
                });
            },
        },
        "#profile_pw_form"
    );

    $("body").on(
        {
            click: function () {
                console.log("add to cart");
                window.Dibook.cart.addItems([$(this).data("id")]).then(
                    () =>
                        function (data) {
                            //TODO: user feedback
                        }
                );
            },
        },
        ".add-to-cart-btn"
    );

    $("body").on(
        {
            click: function (e) {
                window.Dibook.cart.removeItems([e.target.dataset.id]);
            },
        },
        ".remove-cart-btn"
    );

    $("body").on(
        {
            change: function () {
                if ($(this).prop("checked")) {
                    window.Dibook.wishlist.addItems([$(this).val()]).then(
                        () =>
                            function (data) {
                                //TODO: user feedback
                            }
                    );
                } else {
                    window.Dibook.wishlist.removeItems([$(this).val()]).then(
                        () =>
                            function (data) {
                                //TODO: user feedback
                            }
                    );
                }
            },
        },
        ".add-to-faves-btn input"
    );

    $("body").on(
        {
            submit: function (e) {
                e.preventDefault();
                var form = $(this);
                if (googleRecaptchaSiteKey) {
                    grecaptcha.ready(function () {
                        grecaptcha
                            .execute(googleRecaptchaSiteKey, { action: "submit" })
                            .then(function (token) {
                                $("#lostPwGoogleRecapcthaToken").val(token);
                                submitLostPwForm(form);
                            });
                    });
                } else {
                    submitLostPwForm(form);
                }
            },
        },
        "#lost_pw_form"
    );

    if ($("#xmasmodal").length > 0) {
        $("#xmasmodal").modal("show");
        var now = new Date();
        var time = now.getTime();
        var expireTime = time + 1000 * 3600 * 24 * 365;
        now.setTime(expireTime);
        document.cookie = "dibookxmas=seen;expires=" + now.toGMTString() + " path=/";
    }

    if ($("#payment-widget-cartpage-container-shower").length > 0) {
        $("#payment-widget-cartpage-container-shower").click(function () {
            if ($(this).hasClass("open")) {
                $("#payment-widget-cartpage-container").fadeOut();
                $(this).removeClass("open");
            } else {
                $("#payment-widget-cartpage-container").fadeIn();
                $(this).addClass("open");
            }
        });
    }

    showRegistrationSuccessModal();
});

function pixels() {
    if ($(".itemdata").length > 0) {
        var itemData = $(".itemdata").data();

        window.contentViewProperties = {
            contentType: "Product",
            currency: "HUF",
            id: itemData.id.toString(),
            name: itemData.title,
            quantity: 1.0,
            unit: "pcs.",
            unitPrice: itemData.price,
            brand: itemData.publisher,
            category: itemData.category,
            customerValue: 150.0,
            ean: itemData.isbn.toString(),
            imageUrl: itemData.image,
            list: "ProductPage",
            variant: itemData.type == 1 ? "ebook" : "audio",
        };

        bp("track", "contentView", contentViewProperties);
        fbq("track", "ViewContent", {
            content_name: itemData.title,
            value: itemData.price,
            currency: "HUF",
            content_ids: itemData.isbn.toString(),
            content_type: "product",
        });
    }

    function setItemData(itemData) {
        var contentViewProperties = {
            contentType: "Product",
            currency: "HUF",
            id: itemData.id.toString(),
            name: itemData.title,
            quantity: 1.0,
            unit: "pcs.",
            unitPrice: itemData.price,
            brand: itemData.publisher,
            category: itemData.category,
            customerValue: 150.0,
            ean: itemData.isbn.toString(),
            imageUrl: itemData.image,
            list: "ProductPage",
            variant: itemData.type == 1 ? "ebook" : "audio",
        };

        return contentViewProperties;
    }

    $(".widget-bookcard").each(function () {
        var item = $(this).data();

        $(this)
            .find("a")
            .click(function () {
                bp("track", "clickProduct", setItemData(item));
                fbq("track", "PageView", {
                    content_name: itemData.title,
                    value: itemData.price,
                    currency: "HUF",
                    content_ids: itemData.isbn.toString(),
                    content_type: "product",
                });
            });
    });
}

//
function submitRegForm(form) {
    var submit = false;

    if (submit) {
        return false;
    } else {
        submit = true;
        form.find("button.btn").attr("disabled", true);

        $.post(form.attr("action"), form.serialize(), function (response) {
            $(".invalid-feedback").hide();
            submit = false;
            form.find("button.btn").removeAttr("disabled");
            if (response.success) {
                $("#commonmodal .h4").text(response.message.title);
                $("#commonmodal .modal-body-content").html(response.message.content);
                $("#commonmodal button.okbutton").text(response.message.buttonText).show();
                $("#commonmodal")
                    .modal("show")
                    .on("hidden.bs.modal", function () {
                        location.href = location.href;
                    });
                $("#loginModal").modal("hide");
            } else {
                $.each(response.errors, function (key, value) {
                    $('.reg-form input[name="' + key + '"] + .invalid-feedback')
                        .text(value)
                        .show();
                });
            }
        }).fail(({ responseJSON }) => {
            submit = false;
            form.find("button.btn").removeAttr("disabled");
            const errors = responseJSON.errors;
            $(".reg-form .invalid-feedback").hide();
            $(".reg-form .with-invalid-text-color").removeClass("text-danger");
            $(".reg-form .with-invalid-text-color a").removeClass("text-danger");
            for (const [key, value] of Object.entries(errors)) {
                if (key === "confirm") {
                    $('.reg-form input[name="' + key + '"] + .with-invalid-text-color').addClass(
                        "text-danger"
                    );
                    $('.reg-form input[name="' + key + '"] + .with-invalid-text-color a').addClass(
                        "text-danger"
                    );
                } else if (key === "password") {
                    $(".reg-form .register-password + .invalid-feedback").text(value).show();
                } else {
                    $('.reg-form input[name="' + key + '"] + .invalid-feedback')
                        .text(value)
                        .show();
                }
            }
        });
    }
} //end func: submitRegForm

//
function submitLostPwForm(form) {
    $.post(form.attr("action"), form.serialize(), function (response) {
        if (response.success) {
            $("#lostPwModal").modal("hide");
        }
        $("#commonmodal .h4").text("");
        $("#commonmodal .modal-body-content").text(response.message);
        $("#commonmodal button.okbutton").text("Rendben");
        $("#commonmodal").modal("show");
    });
} //end func: submitLostPwForm

//
var submitProgress = false;

function submitContactForm(form) {
    submitProgress = true;
    $("#contact-form button").addClass("loading").css("opacity", "0.4");
    $.post("", form.serialize(), function (response) {
        if (response.success) {
            $("#commonmodal .h4").text("Üzeneted megkaptuk, köszönjük.");
            $("#commonmodal .modal-body-content").html(
                "48 órán belül felvesszük veled a kapcsolatot e-mailben vagy telefonon.<br /><br />Üdvözlettel:<br /> a DiBook csapata"
            );
            $("#commonmodal button.okbutton").text("Rendben");
            $("#commonmodal").modal("show");
        } else {
            $("#commonmodal .h4").text("Probléma");
            $("#commonmodal .modal-body-content").html(response.message);
            $("#commonmodal button.okbutton").text("Rendben");
            $("#commonmodal").modal("show");
        }
    });
} //end func: submitContactForm

//
const banner = document.querySelector(".banner");
const bannerFooter = document.querySelector(".banner-footer");
const bannerToggle = document.getElementById("banner-toggle");
if (bannerToggle) {
    bannerToggle.addEventListener("click", () => {
        banner.classList.toggle("banner__open");
        bannerFooter.classList.toggle("block");
    });
} //end func: toggleBanner

// Banner Slider
const slider = function () {
    const slides = document.querySelectorAll(".banner-slider>li");
    const btnLeft = document.querySelector(".btn-left");
    const btnRight = document.querySelector(".btn-right");

    let curSlide = 0;
    const maxSlide = slides.length;

    const goToSlide = function (slide) {
        slides.forEach((s, i) => (s.style.transform = `translateX(${(i - slide) * 200}%)`));
    };
    goToSlide(0);

    // Next slide
    const nextSlide = function () {
        if (curSlide === maxSlide - 1) {
            curSlide = 0;
        } else {
            curSlide++;
        }

        goToSlide(curSlide);
    };

    btnRight && btnRight.addEventListener("click", nextSlide);

    // Prev slide
    const prevSlide = function () {
        if (curSlide === 0) {
            curSlide = maxSlide - 1;
        } else {
            curSlide--;
        }
        goToSlide(curSlide);
    };

    btnLeft && btnLeft.addEventListener("click", prevSlide);

    const init = function () {
        goToSlide(0);
    };

    init();
};
slider();

// Edit Rating Modal
const ratingModal = document.getElementById("ratingModal");
const overlay = document.getElementById("overlay");

const closeModal = () => {
    ratingModal.classList.add("hidden");
    overlay.classList.add("hidden");
};

if (overlay) overlay.addEventListener("click", closeModal);

// hide google capture on register modal when googleRecaptchaSiteKey is empty
if (!googleRecaptchaSiteKey) $("#regGoogleRecapcthaTokenContainer").hide();

function showRegistrationSuccessModal() {
    const url = new URL(window.location.href);
    if (url.pathname !== "/") return;
    const success = url.searchParams.get("success");
    if (success === "true") {
        $("#commonmodal .h4").text("Üdvözlünk a DiBookon!");
        $("#commonmodal .modal-body-content").html(
            "<p>Örülünk, hogy regisztráltál.</p><p>Már benn is vagy a DiBook-fiókodban.</p><p>Kellemes nézelődést, jó vásárlást kívánunk!</p>"
        );
        $("#commonmodal button.okbutton").text("Rendben").show();
        $("#commonmodal")
            .modal("show")
            .on("hidden.bs.modal", () => {
                url.searchParams.delete("success");
                window.history.replaceState({}, document.title, url.href);
            });
    }
}
